import { getImageSrc } from "@authentic/loyalty-pwa/util";
import { breakpoints } from "@authentic/loyalty-pwa/util/variables";
import styled from "styled-components";

export const LayoutStyled = styled.div`
  font-family: Nunito Sans;
  max-width: 552px;
  margin: 36px auto;
  background-color: white;
  @media screen and (max-width: ${breakpoints.md}) {
    margin: 0 auto;
  }
`;

export const ActivityEmptyContentStyled = styled.div`
  padding: 36px 24px;
  background-image: url(${getImageSrc(require('../../../../assets/churro-sm.png').default)});
  background-repeat: no-repeat;
  background-position: bottom center;
  padding-bottom: 126px;
`;

export const ActivityContentStyled = styled.div`
  padding: 36px 24px 24px;
  margin: 0 auto;
`;

export const FormTitleStyled = styled.div`
  background-color: #E7E7E7;
  position: relative;
  height: 63px;
  a {
    display: block;
  }
  span {
    font-family: Nunito Sans;
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    line-height: 63px;
    display: block;
    text-align: center;
    letter-spacing: 0.03em;
    text-transform: uppercase;
  }

  svg {
    position: absolute;
    top: 20px;
    left: 36px;
    cursor: pointer;
  }
`;

export const PageDescriptionStyled = styled.div`
  text-align: center;
  margin: 0 0 24px 0;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.02em;
`;

export const PaginatorStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 32px;
  margin-bottom: 14px;
`;

export const Next = styled.div`
  margin-top: 3px;
  margin-left: 10px;
  display: inline-block;
  cursor: pointer;
  &.disabled svg path{
    stroke: rgba(0,0,0, 0.30);
  }

  &.enabled svg path{
    stroke: rgba(0,0,0, 1);
  }
`;

export const Prev = styled.div`
  margin-top: 3px;
  margin-right: 10px;
  display: inline-block;
  cursor: pointer;
  &.disabled svg path{
    stroke: rgba(0,0,0, 0.30);
  }

  &.enabled svg path{
    stroke: rgba(0,0,0, 1);
  }
`;

export const PaginatorItemsContent = styled.div`
  display: flex;
`;

export const PaginatorItem = styled.div`
  width: 31px;
  height: 31px;
  line-height: 32px;
  color: black;
  text-align: center;
  margin: 0 2px;
  cursor: pointer;
  &.active {
    background: #95B040;
    border-radius: 15.5px;
    color: white;
  }
`;

export const SubHeadingActivity = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  color: #000000;
  margin-bottom: 20px;
  margin-top: 32px;
`;


export const CurrentPageInput = styled.input`
  width: 50px;
  height: 30px;
  text-align: center;
  outline: none;
  text-decoration: none;
  margin: 0 12px;
`;

export const ContentCurrentPage = styled.div`

`;